module.exports = __webpack_public_path__ + "static/media/valor4_3_1.d8c409a6.png";